<template>
    <div>
        <div class="card-header">
            <div class="card-header-left">
                <h5>Stage 2 Processes</h5>
                <br>
            </div>
        </div>
        <div class="card-block">
            <div class="row">
                <div class="col-sm-9" v-if="$checkPerm('application.view_applicant_submissions')">
                    <div class="accordion" id="processes">
                        <div v-for="(process, index) in $parent.applicant_processes" class="card">
                            <div v-if="process.process == 'Video Upload'" class="card-header" v-bind:id="'heading' + index">
                                <h2 class="mb-0">
                                    <button class="btn btn-link" type="button" data-toggle="collapse"
                                        v-bind:data-target="'#collapse' + index" aria-expanded="true"
                                        v-bind:aria-controls="'collapse' + index">
                                        Video Upload
                                    </button>
                                </h2>

                                <div v-bind:id="'collapse' + index" class="collapse" v-bind:aria-labelledby="'heading' + index"
                                    data-parent="#processes">
                                    <div class="card-body">
                                        <AppVideo v-bind:applicant_documents="$parent.applicant.documents"
                                            v-bind:opening="$parent.opening_id" />
                                    </div>
                                </div>
                            </div>

                            <div class="card-header" v-bind:id="'heading' + index" v-else-if="process.process == 'CBT'">
                                <h2 class="mb-0">
                                    <button class="btn btn-link" type="button" data-toggle="collapse"
                                        v-bind:data-target="'#collapse' + index" aria-expanded="true"
                                        v-bind:aria-controls="'collapse' + index">
                                        {{process.process}}
                                    </button>
                                </h2>
                                <div v-bind:id="'collapse' + index" class="collapse" v-bind:aria-labelledby="'heading' + index"
                                    data-parent="#processes">
                                    <div class="card-body">
                                        <ApplicantCBT v-bind:applicant_id.number="$parent.applicant_id" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-3">
                    <div class="image-holder">
                        <img src="assets/img/user-icon.jpg" alt="" class="p-b-10">
                    </div>
                    <div class="contact-icon">
                        <p>
                            <b>Stage Actions</b>
                        </p>

                        <button v-if="$checkPerm('application.approve_for_interview')" data-toggle="modal" data-target="#interviewStageModal"
                            class="btn btn-primary btn-sm m-1">
                            Approve for Interview Stage
                        </button>

                        <button class="btn btn-warning btn-sm m-1" data-toggle="modal" data-target="#star" v-if="$parent.applicant.is_starred == '0' && $checkPerm('application.archive')">Keep
                            In View</button>

                        <button class="btn btn-warning btn-sm m-1" data-toggle="modal" data-target="#star" v-if="$parent.applicant.is_starred == '1' && $checkPerm('application.unarchive')">Unarchive
                            Applicant</button>

                        <button v-if="$checkPerm('application.discontinue')" class="btn btn-danger btn-sm m-1"
                            v-on:click="$parent.deleteApplicant()">Discontinue Application</button>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="$checkPerm('application.approve_for_interview')" id="interviewStageModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Approve {{$parent.applicant.firstname + " " +
                            $parent.applicant.lastname}} for Interview Stage.</h5>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="interviewStage">
                            <div class="form-group">
                                <label><b>Interview Location</b></label>
                                <input type="text" class="form-control" name="location" v-model="interview_info.location"
                                    required="required" placeholder="Interview Location" />
                            </div>
                            <div class="form-group">
                                <label><b>Interview Date</b></label>
                                <input type="date" class="form-control" name="date" v-model="interview_info.date"
                                    required="required" />
                            </div>
                            <div class="form-group">
                                <label><b>Interview Time</b></label>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>Start Time</label>
                                            <input type="time" class="form-control" name="start_time" v-model="interview_info.time1"
                                                required="required" />
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="form-group">
                                            <label>End Time</label>
                                            <input type="time" class="form-control" name="start_time" v-model="interview_info.time2" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label><b>Requirements</b></label>
                                <summernote height="300" :model.sync="interview_info.requirements"></summernote>


                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-primary">Submit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">

    import AppVideo from '../AppVideo.vue'
    import ApplicantCBT from '../CBT/ApplicantCBT.vue'
    import summernote from '../Summernote.vue'

    export default {
        name: 'Stage2',
        data() {
            return {
                interview_info: {
                    location: "",
                    date: "",
                    time1: "",
                    time2: "",
                    time: "",
                    requirements: "",
                    process_id: "3",
                    applicant_id: this.$route.params.applicant_id,
                    joblisting_id: this.$route.params.id
                },
            }
        },
        methods: {
            interviewStage() {
                //This also approves applicant for Stage 3
                this.interview_info.time = this.interview_info.time1 + " - " + this.interview_info.time2
                var interview = {
                    what: 'InterviewInformation',
                    data: this.interview_info
                }

                this.$socket.makePostRequest(interview)
                    .then((response) => {
                        if (response.type == "InterviewInformation") {
                            this.$swal.fire("Success", "Applicant approved for next stage.", 'success')

                            setTimeout(() => {
                                window.location.reload()
                            }, 1000)
                        }
                    })
                    .catch((error) => {
                        console.log(error)

                    })
            },
        },
        mounted() {

        },
        components: {
            AppVideo,
            ApplicantCBT,
            summernote,
        }
    }
</script>